class HCBlogPage extends HTMLElement {
    constructor(){
        super();
    }

    connectedCallback() {
        //define class name constants
        this.classHidden = "hidden";
        this.classWidth33 = "lg-up--33";
        this.classWidth25 = "lg-up--25";
        this.classWidth75 = "lg-up--75";

        this.filterButton = this.querySelector("#filter-button");
        this.gridItems = this.querySelectorAll(".grid__item");
        this.filterColumn = this.querySelector("#filter-column");
        this.grid = this.querySelector("#card-grid");
        this.showFilterText = this.querySelector("#show-filter-text");
        this.hideFilterText = this.querySelector("#hide-filter-text");

        if(this.filterButton) {
            this.filterButton.addEventListener('click', (event) => this.toggleFilterColumn());
        }
    }

    checkForMissingComponents() {
        let missingElements = false;
        if(!this.filterColumn) {
            console.error("HCBlogPage: Filter Column is missing");
            missingElements = true;
        }

        if(!this.grid) {
            console.error("HCBlogPage: Blog Grid is missing")
            missingElements = true;
        }

        if(!this.showFilterText) {
            console.error("HCBlogPage: Blog Grid is missing")
            missingElements = true;
        }

        if(!this.hideFilterText) {
            console.error("HCBlogPage: Blog Grid is missing")
            missingElements = true;
        }

        return missingElements;
    }

    toggleFilterColumn() {

        if(this.checkForMissingComponents()) {
            return;
        }

        if(this.filterColumn.classList.contains(this.classHidden)) {
            this.filterColumn.classList.remove(this.classHidden);
            this.filterButton.setAttribute('aria-expanded','true');
            this.filterButton.setAttribute('aria-label',this.filterButton.dataset.hide);
            this.grid.classList.add(this.classWidth75);
            this.showFilterText.classList.add(this.classHidden);
            this.hideFilterText.classList.remove(this.classHidden);
            this.gridItems.forEach((gridItem) => {
                gridItem.classList.remove(this.classWidth25);
                gridItem.classList.add(this.classWidth33);
            })
            return;
        }

        this.filterColumn.classList.add(this.classHidden);
        this.filterButton.setAttribute('aria-expanded','false');
        this.filterButton.setAttribute('aria-label',this.filterButton.dataset.show);
        this.grid.classList.remove(this.classWidth75);
        this.showFilterText.classList.remove(this.classHidden);
        this.hideFilterText.classList.add(this.classHidden);
        this.gridItems.forEach((gridItem) => {
            gridItem.classList.remove(this.classWidth33);
            gridItem.classList.add(this.classWidth25);
        })
    }
}

customElements.define('hc-blog-page', HCBlogPage);